export default "__VITE_PUBLIC_ASSET__5ef047c7__"